import styled from 'styled-components';

export const RecentAccountsWrapper = styled.div`
  width: 100%;
  text-align: left;
  margin-bottom: 8px;
`;

export const RecentAccountsTitle = styled.h2`
  margin: 0 0 8px;
  font-family: 'Poppins', sans-serif;
  font-size: 20px;
  font-weight: 500;
  color: #1f1f1f;
  text-align: center;
  margin-bottom: 20px;
  font-size: 20px;
`;

export const RecentAccountsListContainer = styled.div`
  display: flex;
  flex-direction: column;
  gap: 8px;
  margin-bottom: 16px;
`;

export const RecentAccountItem = styled.button`
  width: 100%;
  display: flex;
  align-items: center;
  gap: 12px;
  padding: 12px 14px;
  border: 1px solid #e5e7eb;
  border-radius: 12px;
  background: #ffffff;
  cursor: pointer;
  text-align: left;
  transition: background 0.15s ease, border-color 0.15s ease;

  &:hover {
    background: #f9fafb;
    border-color: #d1d5db;
  }
`;

export const RecentAccountRow = styled.div`
  position: relative;
  width: 100%;
  border: 1px solid #e5e7eb;
  border-radius: 12px;
  background: #ffffff;
  transition: background 0.15s ease, border-color 0.15s ease;

  &:hover {
    background: #f9fafb;
    border-color: #d1d5db;
  }
`;

export const RecentAccountRowContent = styled.div`
  display: flex;
  align-items: center;
  gap: 12px;
  padding: 12px 14px;
  pointer-events: none;
`;

export const RecentAccountAvatar = styled.span`
  width: 40px;
  height: 40px;
  border-radius: 50%;
  display: flex;
  align-items: center;
  justify-content: center;
  flex-shrink: 0;
  font-family: 'Poppins', sans-serif;
  font-size: 14px;
  font-weight: 600;
  color: #ffffff;
  background: ${({ $color }) => $color};
`;

export const RecentAccountInfo = styled.span`
  display: flex;
  flex-direction: column;
  min-width: 0;
  flex: 1;
  gap: 4px
`;

export const RecentAccountName = styled.span`
  font-family: 'Poppins', sans-serif;
  font-size: 14px;
  font-weight: 600;
  color: #111827;
  white-space: nowrap;
  overflow: hidden;
  text-overflow: ellipsis;
`;

export const RecentAccountEmail = styled.span`
  font-family: 'Poppins', sans-serif;
  font-size: 13px;
  color: #6b7280;
  white-space: nowrap;
  overflow: hidden;
  text-overflow: ellipsis;
`;

export const RecentAccountsDivider = styled.div`
  display: flex;
  align-items: center;
  gap: 12px;
  margin: 8px 0 16px;
  color: #9ca3af;
  font-family: 'Poppins', sans-serif;
  font-size: 13px;

  &::before,
  &::after {
    content: '';
    flex: 1;
    height: 1px;
    background: #e5e7eb;
  }
`;

export const ContinueOtherAccountBtn = styled.button`
  width: 100%;
  height: 48px;
  border: 1.5px solid #e5e7eb;
  border-radius: 12px;
  background: #ffffff;
  color: #374151;
  font-family: 'Poppins', sans-serif;
  font-size: 14px;
  font-weight: 600;
  cursor: pointer;
  transition: background 0.15s ease, border-color 0.15s ease;

  &:hover {
    background: #f9fafb;
    border-color: #d1d5db;
  }
`;

export const RemoveAccountsButton = styled.button`
  display: flex;
  align-items: center;
  justify-content: center;
  gap: 6px;
  margin: 16px auto 0;
  padding: 4px 8px;
  border: none;
  background: none;
  color: #6b7280;
  font-family: 'Poppins', sans-serif;
  font-size: 13px;
  cursor: pointer;

  &:hover {
    color: #374151;
    text-decoration: underline;
  }
`;
